/**
 * @generated SignedSource<<88a229ce324c42ae7af9e0534479616b>>
 * @relayHash fcd43737e1b0d02cbed576b69b38294c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fcd43737e1b0d02cbed576b69b38294c

import type { ConcreteRequest } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type potentialDuplicateSubscription$variables = {
  issueId: string;
};
export type potentialDuplicateSubscription$data = {
  readonly issueUpdated: {
    readonly issueStateUpdated: {
      readonly id: string;
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
    } | null | undefined;
    readonly issueTitleUpdated: {
      readonly id: string;
      readonly title: string;
    } | null | undefined;
  };
};
export type potentialDuplicateSubscription = {
  response: potentialDuplicateSubscription$data;
  variables: potentialDuplicateSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueId"
      }
    ],
    "concreteType": "IssueUpdatedPayload",
    "kind": "LinkedField",
    "name": "issueUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueTitleUpdated",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueStateUpdated",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stateReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "potentialDuplicateSubscription",
    "selections": (v2/*:: as any*/),
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "potentialDuplicateSubscription",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "fcd43737e1b0d02cbed576b69b38294c",
    "metadata": {},
    "name": "potentialDuplicateSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "464c78aec150073ed701c33ea6d7ad0e";

export default node;
